import * as React from "react";
const SvgBackButtonCross = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16.53 17.17",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "back-button-cross_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "back-button-cross_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "m.74.7 15.05 15.77M15.83.7.7 16.47",
	style: {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeMiterlimit: 10,
		strokeWidth: "1.4px"
	}
}))));
export default SvgBackButtonCross;
